import { Component, OnInit } from '@angular/core';
import { DashboardService } from './dashboard.service';
import { colors, AuthorizationSchemeService, AuthorizationScheme, numbers } from '@mango/core';
import { title } from 'process';
import { Regelstatus } from '../core/enums/regelstatus';
import { DatePipe } from '@angular/common';
import { Projectstatus } from '../core/enums/projectstatus';
import { AuthenticationService, LoginUser } from '@mango/authentication';
import { UserService } from '../user/user.service';
import { Router } from '@angular/router';

import packageInfo from 'package.json';

import { environment } from 'src/environments/environment';

@Component({
    selector: 'dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
    myScheme: AuthorizationScheme;
    datePipe: DatePipe;
    
    constructor(private service: DashboardService, private authService: AuthorizationSchemeService, private authenticationService: AuthenticationService, private userService: UserService, private route:Router ) {
        this.myScheme = this.authService.getMyScheme();
        this.datePipe = new DatePipe("nl-NL");        
    }

    nrOfProjectenPerStatus: Promise<any>;
    nrOfProjectregelsPerStatus: Promise<any>;
    nrOfProjectregelsPerAanmaakdatum: Promise<any>;
    nrOfProjectregelsPerWeekAanmaakdatum: Promise<any>;
    nrOfOproepenPerDatum: Promise<any>;
    nrOfHerOproepenPerDatum: Promise<any>;
    nrOfOproepenMailPerWeek: Promise<any>;

    nrFactureren: number;
    nrGoedkeuren: number;
    nrExporteren: number;
    nrProForma: number;
    nrVerzenden: number;

    MiLabProName: string;
    MiLabProVersion: string;
    MiLabProDate: string;
    TestName: string;
    chosenYear: number = new Date().getFullYear();
    chosenYearOproepen: number = new Date().getFullYear();

    id: number;

    canRead(type: string) {
        return this.myScheme.canRead(type);
    }
    
    ngOnInit(): void { 

        if (this.myScheme) {

            this.MiLabProVersion = packageInfo.version;
            this.MiLabProDate = packageInfo.date;
            this.MiLabProName = packageInfo.application;
            
            if (!this.myScheme.canRead('CIJBorculo.Logic.kpInstrument')) {
                // CIJ Omgeving
                if (this.myScheme.canRead('CIJBorculo.Logic.Project')) {
                    this.nrOfProjectenPerStatus = this.getProjectenPerStatus();
                }
            
                if (this.myScheme.canRead('CIJBorculo.Logic.Projectregel')) {
                    this.nrOfProjectregelsPerStatus = this.getProjectregelsPerStatus();
                    this.nrOfProjectregelsPerAanmaakdatum = this.getProjectregelsPerAanmaakdatum();
                    this.nrOfProjectregelsPerWeekAanmaakdatum = this.getProjectregelsPerWeekAanmaakdatum(this.chosenYear);
                }

                if (this.myScheme.canRead('CIJBorculo.Logic.OproepHistorie')) {
                    this.nrOfOproepenPerDatum = this.getOproepenPerDatum();
                    this.nrOfHerOproepenPerDatum = this.getHerOproepenPerDatum();
                    this.nrOfOproepenMailPerWeek = this.getOproepenPerWeek(this.chosenYearOproepen);
                }

                if (this.canDoExact()) {
                    this.getAantalFactureren();
                    this.getAantalProforma();
                    this.getAantalGoedkeuren();
                    this.getAantalVerzenden();
                    this.getAantalExporteren();
                }
            }
            else
            {
                // Klantportaal
                this.route.navigate(['/kpInstrument/kpInstrument/']);                
            }
        }

        if (this.MiLabProName != environment.ApplicationName)
        {   // When Test
            this.MiLabProName = environment.ApplicationName;
        }
            
    }

    getCurrentUser() : LoginUser {
        return this.authenticationService.currentUser;
    }

    
    NextYear() {
        this.chosenYear = this.chosenYear+1;
        this.nrOfProjectregelsPerWeekAanmaakdatum = this.getProjectregelsPerWeekAanmaakdatum(this.chosenYear);        
    }

    LastYear() {
        this.chosenYear = this.chosenYear-1;
        this.nrOfProjectregelsPerWeekAanmaakdatum = this.getProjectregelsPerWeekAanmaakdatum(this.chosenYear); 
    }

    NextYearOproepen() {
        this.chosenYearOproepen = this.chosenYearOproepen+1;
        this.nrOfOproepenMailPerWeek = this.getOproepenPerWeek(this.chosenYearOproepen);        
    }

    LastYearOproepen() {
        this.chosenYearOproepen = this.chosenYearOproepen-1;
        this.nrOfOproepenMailPerWeek = this.getOproepenPerWeek(this.chosenYearOproepen);        
    }

    private getProjectenPerStatus(): Promise<any> {
        return this.service.getProjectenPerStatus().toPromise().then(data => {
            return {
                type: 'bar',
                data: {
                    labels: data.map(x => Projectstatus[x["status"]] || "(Zonder Status)"),
                    datasets: [{
                        label: 'Aantal Projecten',
                        data: data.map(x => x["count_Id"]),
                        backgroundColor: colors.dark_blue,
                        borderWidth: 0
                    }]
                },
                options: {
                    responsive: true,
                    display:true,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                    legend: {
                        display: false
                    },
                    plugins: {
                        datalabels: {
                          display: false
                        }
                    },
                    tooltips: {
                        callbacks: {
                           label: function(tooltipItem) {
                                  return tooltipItem.yLabel;
                           }
                        }
                    }
                }
            };
        });
    }

    private getProjectregelsPerStatus(): Promise<any> {
        return this.service.getProjectregelsPerStatus().toPromise().then(data => {
            return {
                type: 'bar',
                data: {
                    labels: data.map(x => Regelstatus[x["status"]] || "(Zonder Status)"),
                    datasets: [{
                        label: 'Aantal instrumenten',
                        data: data.map(x => x["count_Id"]),
                        backgroundColor: colors.dark_green,
                        borderWidth: 0
                    }]
                },
                options: {
                    responsive: true,
                    display:true,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                    legend: {
                        display: false
                    },
                    plugins: {
                        datalabels: {
                          display: false
                        }
                    },
                    tooltips: {
                        callbacks: {
                           label: function(tooltipItem) {
                                  return tooltipItem.yLabel;
                           }
                        }
                    }
                }
            };
        });
    }

    private getProjectregelsPerAanmaakdatum(): Promise<any> {
        return this.service.getProjectregelsPerAanmaakdatum().toPromise().then(data => {
            return {
                type: 'bar',
                data: {
                    labels: data.map(x => this.datePipe.transform(x["datumAanmaak"],"dd MMM") ),
                    datasets: [{
                        label: 'Aantal instrumenten',
                        data: data.map(x => x["count_Id"]),
                        backgroundColor: colors.dark_green,
                        borderWidth: 0
                    }]
                },
                options: {
                    responsive: true,
                    display:true,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                    legend: {
                        display: false
                    },
                    plugins: {
                        datalabels: {
                          display: false
                        }
                    },
                    tooltips: {
                       callbacks: {
                           label: function(tooltipItem) {
                                  return tooltipItem.yLabel;
                           }
                        }
                    }
                }
            };
        });
    }

    private getProjectregelsPerWeekAanmaakdatum(year: number): Promise<any> {

        type Item = {
            count_Id: number;
            postType: string;
            weeknummerAanmaak: number;
        };

        return this.service.getProjectregelsPerWeekAanmaakdatum(year).toPromise().then(data => {
           
            const groupedByPosttype = data.reduce<Record<string, Item[]>>((acc, item) => {
                if (!acc[item.postType]) {
                    acc[item.postType] = [];
                }
                acc[item.postType].push(item);
                return acc;
            }, {});

            const postTypeColorMap: Record<string, string> = {
                'Balie': '#ea8278',
                'Post': '#ffcd43',
                'Shuttle': '#05bd52',
                'Onbekend': '#9398b3ff',
            };

            const postTypeLabelColorMap: Record<string, string> = {
                'Balie': '#f04333ff',
                'Post': '#58440bff',
                'Shuttle': '#067233ff',
                'Onbekend': '#3c3f50ff',
            };

            const allWeeknummers = new Set<number>();
                Object.values(groupedByPosttype).forEach(arr => {
                arr.forEach(item => allWeeknummers.add(item.weeknummerAanmaak));
                });
                const labels = Array.from(allWeeknummers).sort((a, b) => a - b);

                const datasets = Object.entries(groupedByPosttype).map(([posttype, items], i) => {
                const data = labels.map(week => {
                    return items
                    .filter(item => item.weeknummerAanmaak === week)
                    .reduce((sum, item) => sum + item.count_Id, 0); 
                });

                
                const fallbackColor = '#999999'
                const fallbackLabelColor = '#555555'

                return {
                    label: posttype,
                    data,
                    backgroundColor: postTypeColorMap[posttype] || fallbackColor,
                    datalabels: {
                            align: 'end',
                            anchor: 'end',
                            color: postTypeLabelColorMap[posttype] || fallbackLabelColor,
                            display: function(context) {
                                return context.dataset.data[context.dataIndex] !== 0;
                            }
                        }       
                };
            });
            // Bereken de maximale waarde van alle datasets om de y-as schaal iets op te rekken omdat het label er nog boven moet passen
            
            const numberOfWeeks = datasets[0]?.data.length || 0;
            const sumPerWeek = Array.from({ length: numberOfWeeks }, (_, i) => datasets.reduce((sum, ds) => sum + (ds.data[i] || 0), 0));
            const maxStackedValue = Math.max(...sumPerWeek);
            const margin = maxStackedValue * 0.15 // 15% marge
            const maxValue = Math.ceil(maxStackedValue + margin);            
            const maxYValue = Math.round(maxValue / 100) * 100;

            return {
                type: 'bar',
                data: {
                    labels,
                    datasets
                },
                options: {
                    responsive: true,
                    display:true,
                    scales: {
                        xAxes: [{
                            stacked: true}],
                        yAxes: [{
                            stacked: true,
                            ticks: {
                                beginAtZero: true,
                                max:maxYValue
                            }
                        }]
                    },
                    events: [], /* no hover until bug with destroy/update is fixed */
                    legend: {
                        display: true,
                        position: 'top',
                    },
                    plugins: {
                        datalabels: {
                          display: false
                        }
                    }
                    
                }
            };
        });
    }

    private getOproepenPerWeek(year: number): Promise<any> {

        type Item = {
            count_Id: number;
            postType: string;
            weeknummerAanmaak: number;
        };

        return this.service.getOproepenMaildatum(year).toPromise().then(data => {
                       
            const maxDataValue = Math.max(...data.map(x => x["count_Id"])); 
            const margin = maxDataValue * 0.1; 
            const maxYValueMargin = Math.ceil(maxDataValue + margin);
            const maxYValue = (maxYValueMargin - maxYValueMargin%100)+100;

            return {
                type: 'bar',
                data: {
                    labels: data.map(x => x["weeknummerMail"]),
                    datasets: [{
                        label: 'Aantal oproepen',
                        data: data.map(x => x["count_Id"]),
                        backgroundColor: colors.dark_yellow,
                        borderWidth: 0,
                        datalabels: {
                            align: 'end',
                            anchor: 'end',
                            color: colors.dark_orange
                        }  
                    }]
                },
                options: {
                    responsive: true,
                    display:true,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                max: maxYValue
                            }
                        }]
                    },
                    events: [], /* no hover until bug with destroy/update is fixed */
                    legend: {
                        display: false,
                    },
                    plugins: {
                        datalabels: {
                          display: true
                        }
                    }
                    
                }
            };
        });
    }


    private getOproepenPerDatum(): Promise<any> {

        return this.service.getOproepenPerDatum().toPromise().then(data => {
            return {
                type: 'bar',
                data: {
                    labels: data.map(x => this.datePipe.transform(x["datumOproep"],"dd MMM") ),
                    datasets: [{
                        label: 'Aantal oproepen',
                        data: data.map(x => x["count_Id"]),
                        backgroundColor: colors.dark_yellow,
                        borderWidth: 0
                    }]
                },
                options: {
                    responsive: true,
                    display:true,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                    legend: {
                        display: false
                    },
                    plugins: {
                        datalabels: {
                          display: false
                        }
                    },
                    tooltips: {
                        callbacks: {
                           label: function(tooltipItem) {
                                  return tooltipItem.yLabel;
                           }
                        }
                    }
                }
            };
        });
    }

    private getHerOproepenPerDatum(): Promise<any> {

        return this.service.getHerOproepenPerDatum().toPromise().then(data => {
            return {
                type: 'bar',
                data: {
                    labels: data.map(x => this.datePipe.transform(x["datumOproep"],"dd MMM") ),
                    datasets: [{
                        label: 'Aantal Oproepen',
                        data: data.map(x => x["count_Id"]),
                        backgroundColor: colors.red,
                        borderWidth: 0                        
                    }]
                },
                options: {
                    responsive: true,
                    display:true,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                    legend: {
                        display: false
                    },
                    plugins: {
                        datalabels: {
                          display: false
                        }
                    },
                    tooltips: {
                        callbacks: {
                           label: function(tooltipItem) {
                                  return tooltipItem.yLabel;
                           }
                        }
                    }
                }
            };
        });
    }

    getAantalProforma() {
        this.service.getAantalProForma().toPromise().then(data => {
            this.nrProForma = data[0]["count_Id"];
        });
    }

    getAantalVerzenden() {
        this.service.getAantalVerzenden().toPromise().then(data => {
            this.nrVerzenden = data[0]["count_Id"];
        });
    }

    getAantalFactureren() {
        this.service.getAantalFactureren().toPromise().then(data => {
            this.nrFactureren = data[0]["count_Id"];
        });
    }

    getAantalGoedkeuren() {
        this.service.getAantalGoedkeuren().toPromise().then(data => {
            this.nrGoedkeuren = data[0]["count_Id"];
        });
    }

    getAantalExporteren() {
        this.service.getAantalExporteren().toPromise().then(data => {
            this.nrExporteren = data[0]["count_Id"];
        });
    }

    canDoExact() {
        return this.myScheme.canDo('CIJBorculo.Logic.ExactRequest') && this.myScheme.canDo("CIJBorculo.Logic.FactuurExportExactRequest") && this.myScheme.canDo("CIJBorculo.Logic.ExporteerFactuurExactRequest")
    }

    private getQueryParamsProForma() {
        return {"eq:hasProFormaFactuur": true};
    } 
}
